import type { FaireProductEntity } from "../../entity_types/product";

export const p_6bdocdf2zn: FaireProductEntity = {
  token: "p_6bdocdf2zn",
  type: "product",
  name: "Flying Magic Butterfly® - Rainbow - Assorted Colors",
  brandToken: "b_29d6ca3c",
  brandName: "TOPS Malibu",
  imageUrl: "https://cdn.faire.com/fastly/8bb41e35cc80eb597280306a2614eb0f5dfee2382f7230fcdd8bab64bf3e2c0a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e0e577d2b946b6e8cc845b67f4245319f766df90737cd5732c40c577fa59c6e.jpeg",
    "https://cdn.faire.com/fastly/21da97506cb8e86e6cab7156439e55b8f7038e6038b1d0610369533a4b477802.jpeg",
    "https://cdn.faire.com/fastly/53a4b0847129fe40d98105484926bfae0bd52d0a314f0b1d2cf3a6d7fc5c8b7a.jpeg",
    "https://cdn.faire.com/fastly/9a30dbc7958cdaa40cd4564bb084f2603f8361f32a4c0080f99d8107139ac8b1.jpeg",
    "https://cdn.faire.com/fastly/4e9d4063c6905fee8a296e3f89838db5672a42f595b828b887060f1f46513515.jpeg",
    "https://cdn.faire.com/fastly/0c5f47b0c38b6c5f9097b3267e7b4dc5d586dde2d6dbced2efd6d4cc9237df23.jpeg",
    "https://cdn.faire.com/fastly/01ffdfdbe14535a549188b33563fc9c15ad48c4b3adc0c45765ae0767af0a707.jpeg",
    "https://cdn.faire.com/fastly/9bc0bebdec29fd7ae8aa1e0ce7c16686dd8567543e0145521bc2d2b0fdce3abb.jpeg"
  ],
  priceDollars: 3.45,
  description: "* Handcrafted by artisans in the USA *\n\nEnjoy the surprise and set hearts aflutter with Magic Butterflies®! Simply, wind the wings and tuck the butterfly into a greeting card or book. When the recipient opens the missive, the lovely butterfly takes flight for a joyous surprise! (You might want to issue a gentle warning to anyone who is easily startled.)\n\nPerfect for birthdays, graduations, anniversaries and many other special occasions, these ingenious little creatures - which can be flown over and over again - deliver soaring declarations of love and well wishes.\n\n* Case pack assortment may vary depending on availability.",
  tags: [],
  msrpDollars: 6.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:46:37.423Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
